module.exports = __webpack_public_path__ + "img/qr-code-scan-icon.4b0ac551.svg";